import { AmlInfo, AmlInfoSchema } from '@40seas/entities/aiprize';
import { FromSchema } from '@40seas/entities/common';
import { CreditSafeReportCompliance, CreditSafeReportComplianceSchema } from '@40seas/entities/credit-safe';
import { z } from 'zod';

export const CreditReviewComplianceSchema = z.object({
    amlInfo: AmlInfoSchema.optional(),
    alerts: CreditSafeReportComplianceSchema.optional(),
});

export class CreditReviewCompliance extends FromSchema(CreditReviewComplianceSchema) {
    amlInfo: AmlInfo;
    alerts?: CreditSafeReportCompliance;
}
